// extracted by mini-css-extract-plugin
export default {"hr":"HorizontalLine_hr__XeF1x"};